
define('jst!autocompleter/_loading_no_text',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<li class="item loading-no-text">\n  <div class="icon-16 icon icon-spinner"></div>\n</li>\n');
 });

